/**
 * Web-font loading (Phase 56, committee R-5 / R-10). The always-on stylesheet only carries the Latin faces (Newsreader,
 * IBM Plex Mono); Arabic faces are added on demand so an English visitor to the landing page downloads three font files,
 * not eight:
 *  - `ar`        IBM Plex Sans Arabic — whenever the interface language is Arabic, and always inside the signed-in app
 *                (legal names and holding titles carry Arabic in both languages).
 *  - `arDisplay` Readex Pro 500/600 — the modern geometric Arabic display face used for landing-page h1/h2 in Arabic only
 *                (owner's choice; body text stays IBM Plex Sans Arabic).
 * Idempotent: each stylesheet is appended once per document.
 */
const FONT_LINKS = {
  ar: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@400;500;600;700&display=swap",
  arDisplay: "https://fonts.googleapis.com/css2?family=Readex+Pro:wght@500;600&display=swap",
};

export function ensureFont(key) {
  if (typeof document === "undefined" || !FONT_LINKS[key]) return;
  const id = `tamreer-font-${key}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = FONT_LINKS[key];
  document.head.appendChild(link);
}
